import {
  ApiGetRequest,
  ApiPostRequest,
  ApiPostMultipart,
  ApiDeleteRequest,
  ApiPutRequest,
} from '../../api';
import { showNotif } from '../notification';

export const state = {
  data: {
    title: 'Master Product',
    breadcrumb: [
      {
        text: 'Dashboard',
        href: '/logistic',
      },
      {
        text: 'Master Product',
        href: '/adm/logistic/product',
        active: true,
      },
    ],
    showmodal: false,
    items: [],
    total: 0,
    page: 1,
    limit: 10,
    pageOptions: [10, 25, 50, 100],
    search: '',
    sortBy: 'id_product',
    sortDesc: false,
    fields: [
      {
        key: 'code_prod',
        label: 'Kode',
        sortable: true,
      },
      {
        key: 'kelompok',
        label: 'Kelompok',
      },
      {
        key: 'product',
        label: 'Produk',
        sortable: true,
      },
      {
        key: 'satuan',
        label: 'Satuan',
      },
      {
        key: 'hjual',
        label: 'Jual',
      },
      {
        key: 'aksi',
        label: 'Aksi',
      },
    ],
    fields_choose_product: [
      {
        key: 'code_prod',
        label: 'Kode',
        sortable: true,
      },
      {
        key: 'kelompok',
        label: 'Kelompok',
      },
      {
        key: 'product',
        label: 'Produk',
        sortable: true,
      },
      {
        key: 'satuan',
        label: 'Satuan',
      },
      {
        key: 'hjual',
        label: 'Jual',
      },
    ],
    fields_product: [
      {
        key: 'code_prod',
        label: 'Kode',
        sortable: true,
      },
      {
        key: 'kelompok',
        label: 'Kelompok',
      },
      {
        key: 'product',
        label: 'Produk',
        sortable: true,
      },
      {
        key: 'satuan',
        label: 'Satuan',
      },
      {
        key: 'hjual',
        label: 'Jual',
      },
    ],
    detail: false,
    form: {
      product: '',
      stock: '',
      min_stock: '',
      id_satuan: '',
      merk: '',
      part_number: '',
      hjual: '',
      acc_hpp: '',
      acc_hpp_code: '',
      acc_hpp_name: '',
      acc_jual: '',
      acc_jual_code: '',
      acc_jual_name: '',
      acc_persediaan: '',
      acc_persediaan_code: '',
      acc_persediaan_name: '',
      acc_pengiriman: '',
      acc_pengiriman_code: '',
      acc_pengiriman_name: '',
      acc_retur: '',
      acc_retur_code: '',
      acc_retur_name: '',
      logo: '',
      supplier_product: [
        {
          id_supplier: '',
          code_supplier: '',
          name_supplier: '',
          price_buy: '',
        },
      ],
    },
    tab: [
      { active: true, name: 'Supplier' },
      { active: false, name: 'Kode Akun dan HPP' },
    ],
  },
};

export const getters = {
  form(state) {
    return state.data.form;
  },
  activeTab(state) {
    let activeTab = state.data.tab.filter((item) => item.active === true);
    return activeTab ? activeTab[0].name : 'Supplier';
  },
};

export const mutations = {
  changeProduct(state, data) {
    state.data = Object.assign({}, state.data, data);
  },
};

export const actions = {
  async searchProduct(context, params = null) {
    let result = await ApiGetRequest(`logistic/product`, params);
    return !result.error ? result.data.object : [];
  },

  async uploadImageProduct({ commit, state }, payload) {
    commit('changeProduct', {
      loading: true,
    });

    const { data } = state;
    const result = await ApiPostMultipart(`opr/photo`, payload);
    commit('changeProduct', {
      loading: false,
    });

    if (!result.error) {
      commit('changeProduct', {
        form: {
          ...data.form,
          logo: result.data.object ? result.data.object.path : '',
        },
      });

      return true;
    }

    return false;
  },

  async getListProduct({ commit, state }) {
    commit('changeProduct', {
      loading: true,
    });

    const { data } = state;
    let params = {
      q: data.search,
      limit: data.limit,
      page: data.page,
      sort: data.sortBy,
      order: data.sortDesc ? 'desc' : 'asc',
    };

    let result = await ApiGetRequest(`logistic/product`, params);
    commit('changeProduct', {
      items: !result.error ? result.data.object : [],
      total: !result.error ? result.data.total : 0,
      loading: false,
    });

    return !result.error ? true : false;
  },

  async getDetailProduct({ commit, state }, payload = null) {
    commit('changeProduct', {
      loading: true,
    });

    const { data } = state;
    let result = await ApiGetRequest(`logistic/product/${payload.id}`);
    commit('changeProduct', {
      loading: false,
      detail: result.error ? false : result.data.object,
      form: {
        ...data.form,
        ...result.data.object,
      },
    });

    return result.error ? false : true;
  },

  async createProduct({ commit, state, dispatch }) {
    commit('changeProduct', {
      loading: true,
    });

    let result = await ApiPostRequest(`logistic/product`, state.data.form);
    commit('changeProduct', {
      loading: false,
    });

    if (!result.error) {
      showNotif(dispatch, {
        message: result.data.message,
      });
    }

    return result.error ? false : true;
  },

  async updateProduct({ commit, state, dispatch }, payload = null) {
    commit('changeProduct', {
      loading: true,
    });

    let result = await ApiPutRequest(
      `logistic/product/${payload.id}`,
      state.data.form
    );

    commit('changeProduct', {
      loading: false,
    });

    if (!result.error) {
      showNotif(dispatch, {
        message: result.data.message,
      });
    }

    return result.error ? false : true;
  },

  async deleteProduct({ commit, dispatch }, payload = null) {
    commit('changeProduct', {
      loading: true,
    });

    let result = await ApiDeleteRequest(`logistic/product/${payload.id}`);
    commit('changeProduct', {
      loading: false,
    });

    if (!result.error) {
      showNotif(dispatch, {
        message: result.data.message,
        type: 'success',
      });
    }

    return result.error ? false : true;
  },
};
